import { render, staticRenderFns } from "./general-tab-partial.vue?vue&type=template&id=66ea23fb"
import script from "./general-tab-partial.vue?vue&type=script&lang=js"
export * from "./general-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports